import moment from "moment";
import { FunctionComponent } from "react";
import { Link } from "react-router-dom";
import { getPlannerItemTypeText } from "src/components/Planner/utils";
import { localize } from "src/l10n";
import { Label } from "src/ui";
import { shortenString } from "src/utils";
import Visage2Icon from "src/visage2/Visage2Icon/Visage2Icon";
import "./SocialPlannerItem.scss";

interface IProps {
    post: Spintr.ISocialPlannerItem;
}

const dateFormat = "YYYY-MM-DD";
const dateTimeFormat = "YYYY-MM-DD HH:mm";

const formatDateRange = (post: Spintr.ISocialPlannerItem): string => {
    const format = post.allDayEvent ? dateFormat : dateTimeFormat;
    const start = moment(post.startsAt);
    const end = moment(post.endsAt);

    if (post.allDayEvent && start.isSame(end, "day")) {
        return start.format(format);
    }

    return start.format(format) + " – " + end.format(format);
};

const SocialPlannerItem: FunctionComponent<IProps> = (props) => {
    const { post } = props;

    const categoryName = post.categoryIsLangTag
        ? localize(post.categoryName)
        : post.categoryName;

    const details = [getPlannerItemTypeText(post.itemType), categoryName, post.location]
        .filter((text) => !!text && text.length > 0)
        .join(" · ");

    return (
        <div className="SocialPlannerItem shared-post shared-content-post">
            <Label className="shared-content-post-title" weight="medium" size="body-2">
                <Link
                    className="linkFGColor general-row-break"
                    to={`/goto/${post.Id}`}
                >
                    {post.name}
                </Link>
            </Label>
            <div className="SocialPlannerItem-meta">
                <Visage2Icon icon="calendar-1" color="mid-grey" size="small" />
                <Label size="body-3" color="mid-grey">
                    {formatDateRange(post)}
                </Label>
            </div>
            {post.description && post.description.length > 0 && (
                <Label size="body-3" className="general-row-break">
                    {shortenString(post.description, 200, "...")}
                </Label>
            )}
        </div>
    );
};

export default SocialPlannerItem;
